import { Strings } from 'Strings';
import { stripeLib } from 'services/AsyncJSLoader';
import { jqueryPaymentLib } from 'lazy_modules';
import { SubscriptionCtrl } from './Subscriptions';
import { Utils } from 'underscore-extensions';
import { HttpSvcFactory } from '../../services/HttpSvc';
import { AuthenticationSvc } from '../../services/AuthenticationSvc';
import { SubscriptionSvc } from '../services/SubscriptionSvc';

type Card = {
    cvc: string;
    email: string;
    number: number;
    expiry: {
        month: number;
        year: number;
    };
    zip?: string;
    name?: string;
};
const testScope = {
    card_exp_month: '12',
    card_exp_year: '17',
    card: {
        number: '4242 4242 4242 4242',
        expiry: {
            month: 12,
            year: new Date()
                .getFullYear()
                .toString()
                .slice(2)
        },
        cvc: '123'
    }
};

const getHashByFormData = (formData: {}) =>
    window.btoa(
        _.values<string>(formData)
            .map(v => v.replace(/\s*/g, ''))
            .join('')
    );

const getStripeData = (stripForm: HTMLElement) =>
    window.Stripe.utils.paramsFromForm(
        stripForm,
        window.Stripe.card.whitelistedAttrs
    );

const getHashByStripeForm = _.compose(getHashByFormData, getStripeData);

const IdempotencyHeader = 'Idempotency-Key';

interface StripeFormScope extends ng.IScope {
    stripeLoaded: boolean;
    pluginsLoaded: boolean;
    requiredFields: boolean;
    showFillTestCard: boolean;
    billing: {
        period: any;
    };
    stripeForm: ng.IFormController;
    card: Card;
    coupon: { code?: string };
    upgrade?: {
        name: string;
        project?: boolean;
        projectId: string;
    };
    setRequiredFields: () => void;
    submit: (any: any) => void;
    fillTestCard: () => void;
}

class StripeForm {
    constructor(
        private $scope: StripeFormScope,
        private $element: ng.IAugmentedJQuery,
        private $timeout: ng.ITimeoutService,
        private $ocLazyLoad: oc.ILazyLoad,
        private $stateParams: { promo: string; coupon: string },
        private $rootScope: ng.IRootScopeService,
        private HttpSvc: HttpSvcFactory,
        private subscriptionSvc: SubscriptionSvc,
        private AuthenticationSvc: AuthenticationSvc
    ) {
        const ctrl: SubscriptionCtrl = $element.controller('subscription');

        $scope.stripeLoaded = false;
        $scope.pluginsLoaded = false;
        $scope.card = {} as Card;
        $rootScope.coupon = { code: $stateParams.promo || $stateParams.coupon };

        $scope.setRequiredFields = () => ($scope.requiredFields = false);
        stripeLib().then(() => {
            $scope.stripeLoaded = true;
            $scope.submit = upgradeModal => {
                $scope.requiredFields = true;
                $timeout(() => {
                    if ($scope.stripeForm.$invalid) return;

                    const stripeForm = angular.element($element)[0];
                    const idempotencyKey = getHashByStripeForm(stripeForm);

                    ctrl.loading = true;

                    window.Stripe.setPublishableKey(options.user.stripeKey()); //IE 10 problems
                    window.Stripe._allowedCustomHeaders.push(IdempotencyHeader);
                    window.Stripe._setCustomHeader(
                        IdempotencyHeader,
                        idempotencyKey
                    );

                    const formParams: anm.ChangeSubscriptionRequest = {
                        token: '',
                        name: $scope.upgrade ? $scope.upgrade.name : '',
                        period: $scope.billing.period.toUpperCase(),
                        email: undefined as string | undefined,
                        couponCode: undefined as string | undefined
                    };
                    const email = $scope.card.email;
                    if (!Strings.isBlank(email)) formParams.email = email;

                    window.Stripe.createToken(
                        stripeForm,
                        (status, tokenResponse) => {
                            if (!ctrl.errorResponse(tokenResponse)) {
                                const token = tokenResponse.id;
                                let resolvePromise: ng.IPromise<any>;
                                formParams.token = token;

                                if (ctrl.showEditCard) {
                                    resolvePromise = ctrl.updateCard(token);
                                } else {
                                    formParams.couponCode =
                                        $rootScope.coupon.code;

                                    // if ($scope.upgrade.project) {
                                    //     ctrl.upgradeProject(formParams.period,
                                    //         $scope.upgrade.projectId,
                                    //         formParams.token,
                                    //         formParams.name,
                                    //         formParams.couponCode,
                                    //         upgradeModal
                                    //     );
                                    // } else {

                                    const {
                                        exp_month,
                                        exp_year
                                    } = tokenResponse.card;
                                    subscriptionSvc.checkExpired(
                                        `${exp_month}/${exp_year}`
                                    );

                                    resolvePromise = ctrl.upgradeSubscription(
                                        formParams
                                    );
                                    // }
                                }
                                if (!Strings.isBlank(email)) {
                                    resolvePromise.finally(() =>
                                        this.updateEmail(email)
                                    );
                                }
                            }
                        }
                    );
                });
            };
            $scope.$apply();
        });

        Utils.sequence(jqueryPaymentLib, $ocLazyLoad).then(() => {
            $scope.pluginsLoaded = true;
            $scope.$apply();
        });

        $scope.showFillTestCard = !options.isProduction;

        $scope.fillTestCard = () => {
            ['number', 'expiry_year', 'expiry_month', 'cvc'].forEach(k => {
                $scope.stripeForm[k].isValid = true;
            });
            _.extend($scope, testScope);
        };
    }

    updateEmail(email: string) {
        this.HttpSvc<ApiError>('profile')
            .securePut({ email })
            .then(() => this.AuthenticationSvc.updateUser());
    }
}

angular.module('animatronApp.settings').directive('stripeForm', () => ({
    restrict: 'E',
    require: '^subscription',
    transclude: true,
    controller: StripeForm,
    template: `<form form-autofill-fix name="stripeForm" ng-submit="submit(upgradeModal)" id="stripe-form" class="form-horizontal"><ng-transclude></ng-transclude></form>`
}));



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/stripeFormDirective.ts